import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ChatService, UserService } from '@app/core';
import { IChat } from '@app/core/models/chat';
import { CommonService } from '@app/core/services/common.service';
import { environment } from '@environments/environment';

@Component({
  selector: 'app-chat-data',
  templateUrl: './chat-data.component.html',
  styleUrls: ['./chat-data.component.scss'],
})
export class ChatDataComponent implements OnInit {
  @Input() chatData: any = [];
  @Input() room = '';
  @Input() selectedSport = '';
  assetUrl = environment.assetUrl;
  @Input() paging = false;
  @Input() replies = false;
  @Output() loadMore = new EventEmitter();
  constructor(
    public _user: UserService,
    private _common: CommonService,
    private _chat: ChatService
  ) {}

  ngOnInit() {
    if (this._common.isBrowser) {
      this._chat._socket.removeListener('likeunlike-message');
      this._chat._socket.on('likeunlike-message', (data: any) => {
        this.chatData = this.chatData.map((chat: any) => {
          if (data.child_id && chat.id == data.child_id) {
            chat.replies = chat.replies.map((reply: any) => {
              if (reply.id === data.message_id) reply.like_arr = data.likes;
              return reply;
            });
          } else if (chat.id === data.message_id) chat.like_arr = data.likes;
          return chat;
        });
      });
    }
  }

  ngOnChanges(): void {
    let room = this.room;
    if (!room || !this._common.isBrowser) return;
    this._chat._socket.emit('join-room', {
      room: room,
      oldroom: room,
    });
    this._chat._socket.removeListener(room);
    /* CHECK ROOMS DATA */
    this._chat._socket.on(room, (data: IChat) => {
      if (!data.child_id) {
        this.chatData.unshift(data);
      } else {
        let replyobj = true;
        this.chatData = this.chatData?.map((chat: any) => {
          if (chat.id == data.child_id) {
            replyobj = false;
            chat.replies = chat.replies || [];
            chat.replies.unshift(data);
            chat.repliesCount = chat.replies.length;
          }
          return chat;
        });
        if (replyobj) {
          this.chatData.unshift(data);
        }
      }
    });
  }

  /**
   * function which is use for like or unlike messages
   * @param msg
   */
  likeUnlike(chat: any) {
    if (!this._user.isLoggedIn() || !this._common.isBrowser) return;
    let user = this._user.authUser.getValue();
    let obj = {
      room: this.room,
      message_id: chat.id,
      child_id: chat.child_id,
      liked_of: chat.user_id,
      liked_by: user.id,
      liked_by_name: user.name,
      likes: chat.like_arr ? chat.like_arr.split(',') : [],
      is_liked: true,
    };
    let liked = obj.likes.indexOf(user.id.toString());
    if (liked !== -1) {
      obj['is_liked'] = false;
      obj.likes.splice(liked, 1);
    } else {
      obj.likes.push(user.id.toString());
    }
    chat.like_arr = obj.likes.join(',');
    return this._chat._socket.emit('likeunlike-message', obj);
  }

  async getReplies(obj: IChat) {
    obj.showReply = !obj.showReply;
    if (
      obj.repliesCount == 0 ||
      (obj.replies && obj.repliesCount == obj.replies.length)
    ) {
      return;
    }
    obj.loading = true;
    let replies = await this._chat.getReplies(obj.id);
    obj.replies = replies.data as IChat[];
    obj.loading = false;
  }

  /**
   * function which is use for reply message
   * @param msgobj
   * @returns
   */
  async replyMessage(msgobj: { msg: string }, chat: any) {
    if (!this._user.isLoggedIn()) return;
    if (!msgobj.msg) return;
    let room = this.room;
    let user: any = this._user.authUser.getValue();
    let obj = {
      child_id: chat.id,
      user_id: user.id,
      at_id: chat.user_id,
      reply_by_name: user.name,
      message: msgobj.msg,
      sport: chat.sport,
      avatar: this.assetUrl + '/' + user.user_avatar,
      sport_winnings: chat.sport
        ? user[`${chat.sport?.toLowerCase()}_total_winnings`]
        : user['kingpin_rank'],
      sport_rank: chat.sport
        ? user[`${chat.sport?.toLowerCase()}_rank`]
        : user['total_winnings'],
      username: user.name,
      membership: user.membership,
      room: room,
    };
    this._chat._socket.emit('chat', obj);
  }

  loadMoreData(button: any) {
    this.loadMore.next(button);
  }

  ngOnDestroy(): void {
    if (this._common.isBrowser) {
      this._chat._socket.removeListener('likeunlike-message');
      this._chat._socket.removeListener(this.room);
    }
  }
}
